import * as Constants from "../constants";

export const getActiveLiveSessionByCourse = () => ({
  type: Constants.GET_ACTIVE_LIVE_SESSION_BY_COURSE,
});

export const getActiveLiveSessionByCourseSuccess = (data) => ({
  type: Constants.GET_ACTIVE_LIVE_SESSION_BY_COURSE_SUCCESS,
  payload: data,
});

export const getActiveLiveSessionByCourseError = (error) => ({
  type: Constants.GET_ACTIVE_LIVE_SESSION_BY_COURSE_ERROR,
  error,
});

export const setLiveSessionInitialState = () => ({
  type: Constants.SET_LIVE_SESSION_INITIAL_STATE,
});

export const setLocalLiveSessionStreaming = () => ({
  type: Constants.SET_LOCAL_LIVE_SESSION_STREAMING,
});

export const getLiveSessionsList = ({ pageSize }) => ({
  type: Constants.GET_LIVE_SESSIONS_LIST,
  pageSize,
});

export const getLiveSessionsListSuccess = (data) => ({
  type: Constants.GET_LIVE_SESSIONS_LIST_SUCCESS,
  payload: data,
});

export const getLiveSessionsListError = (error) => ({
  type: Constants.GET_LIVE_SESSIONS_LIST_ERROR,
  error,
});

export const getLiveSession = (liveSessionId) => ({
  type: Constants.GET_LIVE_SESSION,
  liveSessionId,
});

export const getLiveSessionSuccess = (data) => ({
  type: Constants.GET_LIVE_SESSION_SUCCESS,
  payload: data,
});

export const getLiveSessionError = (error) => ({
  type: Constants.GET_LIVE_SESSION_ERROR,
  error,
});

export const createLiveSession = (courseId, data) => ({
  type: Constants.CREATE_LIVE_SESSION,
  courseId,
  data,
});

export const createLiveSessionSuccess = (data) => ({
  type: Constants.CREATE_LIVE_SESSION_SUCCESS,
  payload: data,
});

export const createLiveSessionError = (error) => ({
  type: Constants.CREATE_LIVE_SESSION_ERROR,
  error,
});

export const updateLiveSession = () => ({
  type: Constants.UPDATE_LIVE_SESSION,
});

export const updateLiveSessionSuccess = (data) => ({
  type: Constants.UPDATE_LIVE_SESSION_SUCCESS,
  payload: data,
});

export const updateLiveSessionError = (error) => ({
  type: Constants.UPDATE_LIVE_SESSION_ERROR,
  error,
});

export const setLiveSessionState = (liveSessionId, event) => ({
  type: Constants.SET_LIVE_SESSION_STATE,
  liveSessionId,
  event,
});

export const setLiveSessionStateSuccess = (data, event) => ({
  type: Constants.SET_LIVE_SESSION_STATE_SUCCESS[event],
  payload: data,
});

export const setLiveSessionStateError = (error, event) => ({
  type: Constants.SET_LIVE_SESSION_STATE_ERROR[event],
  error,
});
